<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">配信メール変更</h1>
    </div>
    <div id="MailSetting" class="detail-cart my-5 border box-p-20">
      <!-- 動的HTML生成部 配信頻度 -->
    <div v-if="!shopping">
      <h2 class="mb-2 text-left">実績メールの配信頻度</h2>
      <div class="c-radio mb-5">
        <div class="radio_box d-flex">
          <div v-for="item in mailTimesCodeMaster.slice(0, 2)" :key="item.Key">
            <input
              type="radio"
              :id="'t' + item.Key"
              v-model="t1"
              :value="item.Key"
              class="mt-n1"
            />
            <label :for="'t' + item.Key">{{ item.Value }}</label>
          </div>
        </div>
        <div class="radio_box d-flex">
          <div v-for="item in mailTimesCodeMaster.slice(2, 6)" :key="item.Key">
            <input
              type="radio"
              :id="'t' + item.Key"
              v-model="t1"
              :value="item.Key"
              class="mt-n1"
            />
            <label :for="'t' + item.Key">{{ item.Value }}</label>
          </div>
        </div>
        <p>
          ・「配信なし」を選択した場合、お知らせメールのみ希望となります。<br />・「月1回」を選択した場合、毎月末日に実績メールの配信を行います。<br />・「月3回」を選択した場合、毎月末の3日間に実績メールの配信を行います。<br />・「月4回」を選択した場合、毎月15日と毎月末の3日間に実績メールの配信を行います。<br />・「月8回」を選択した場合、毎月5日、10日、15日、20日、25日、月末の3日間に実績メールの配信を行います。<br />・「全営業日」を選択した場合、毎月約20回程度実績メールの配信を行います。
        </p>
      </div>
    </div>
      <h2 class="mb-2 text-left">弊社からのお知らせ</h2>
      <div class="c-radio">
        <div class="radio_box d-flex">
          <div>
            <input
              type="radio"
              id="t21"
              v-model="t2"
              value="true"
              class="mt-n1"
            />
            <label for="t21">希望する</label>
          </div>
          <div>
            <input
              type="radio"
              id="t22"
              v-model="t2"
              value="false"
              class="mt-n1"
            />
            <label for="t22">希望しない</label>
          </div>
        </div>
      </div>
    </div>
    <div class="my-5 text-center">
      <button
        id="UpdateMailTims"
        v-on:click="chageMailTimes"
        class="btn d-inline-block"
      >
        上記の内容に変更する
      </button>
    </div>
    <div class="mb-5 text-center">
      <router-link to="/settings" class="btn d-inline-block" >会員情報を変更へ戻る</router-link >
    </div>
  </section>
</template>

<style>
.detail-cart div.c-radio div.radio_box div {
  min-width: 20%;
  margin-bottom: 10px;
}
.detail-cart div.c-radio div.radio_box label {
  font-weight: bold;
  cursor: pointer;
  font-size: 1.125em;
}
</style>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
let request = new Request();
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
export default {
  data() {
    return {
      t1: "",
      t2: "",
      mailTimesCodeMaster: [],
      wantNotifyMailMaster: [],
      shopping:false,
    };
  },
  mounted() {
    this.getMailTimes(this.memberNo, 1);
    this.shopping = auth.getShopping();
    window.scroll(0, 0);
  },
  methods: {
    getMailTimes() {
      let requestParams = request.createParams(
        "webMdlMemberInfo",
        "getMailTimes",
        []
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.mailTimesCodeMaster = data.mailTimeCodeMaster;
          this.wantNotifyMailMaster = data.wantNotifyMailMaster;

          this.t1 = data.MailTimesCode;
          this.t2 = data.WantNotifyMail;
        });
    },
    chageMailTimes() {
      const newMailTimeCode = this.mailTimesCodeMaster.find(
        (item) => item.Key === this.t1
      );
      const newWantNotifyMail = this.wantNotifyMailMaster.find(
        (item) => item.Key.toString() === this.t2.toString()
      );
      let msg =
        "下記内容で変更します。よろしいですか？\n\n" ;
      let text = 
        "配信頻度：" +
        newMailTimeCode.Value +
        "\n\n" +
        "お知らせ：" +
        newWantNotifyMail.Value;
      Message.confirm()
        .fire({
          title: msg,
          text : text,
        })
        .then((result) => {
          if (result.value) {
            let postParams = [this.t1, this.t2];
            let requestParams = request.createParams(
              "webMdlMemberInfo",
              "updMailTimes",
              postParams
            );
            request
              .create()
              .post("", requestParams)
              .then((data) => {
                Message.success().fire({
                  title: data.msg,
                  position: "center",
                  showConfirmButton: true,
                  timer: null,
                  toast: false,
                });
              });
          }
        });
    },
  },
};
</script>
